export const categoriesMap: Record<string, string[]> = {
  'Fruta': [
    'Plátano y uva',
    'Manzana y pera',
    'Melón y sandía',
    'Cítricos',
    'Fruta tropical',
    'Otras frutas'
  ],
  'Verdura': [
    'Patata',
    'Cebolla y ajo',
    'Tomate',
    'Pepino y zanahoria',
    'Calabacín y pimiento',
    'Repollo y col',
    'Setas y champiñones',
    'Hierbas aromáticas',
    'Otras verduras y hortalizas',
    'Verduras al vapor'
  ],
  'Pescado fresco': [
    'Salmón',
    'Dorada',
    'Lubina',
    'Merluza',
    'Bacalao',
    'Corvina',
    'Sepia, pulpo y calamar',
    'Trucha',
    'Lenguado',
    'Boquerón',
    'Rodaballo',
    'Sardina',
    'Otros'
  ],
  'Marisco': [
    'Marisco',
    'Marisco de concha',
    'Marisco de concha y otros',
    'Surimi y otros'
  ],
  'Carne': [
    'Cerdo',
    'Vacuno',
    'Conejo',
    'Cordero',
    'Hamburguesas',
    'Picadas y otros'
  ],
  'Aves y pollo': [
    'Pollo',
    'Pavo y otras aves'
  ],
  'Embutidos': [
    'Jamón serrano',
    'Chorizo',
    'Salchichón',
    'Lomo y otros',
    'Jamón cocido',
    'Bacón',
    'Salchichas'
  ],
  'Quesos': [
    'Queso untable',
    'Queso fresco',
    'Queso roquefort, camembert y cabra',
    'Queso curado',
    'Queso semicurado',
    'Queso tierno',
    'Queso lonchas',
    'Queso rallado',
    'Queso en porciones'
  ],
  'Pan y bollería': [
    'Barra de pan',
    'Pan de bocadillo',
    'Pan rebanado',
    'Pan de molde',
    'Pan de hamburguesa y wrap',
    'Bollería dulce',
    'Bollería salada',
    'Bollería envasada'
  ]
};